import PreviousPeriodDataCard from 'components/data-card/variants/previous-period-data-card/previous-period-data-card.component';
import { useSearchQueryContext } from 'components/search/search.hooks';
import SummaryCardBoundary from 'components/summary-card-boundary/summary-card-boundary.component';
import { useTranslation } from 'react-i18next';

const queryName = 'locationsPerformanceSummaryQuery';

const LocationLoyaltyPerformanceSummaryCards = () => {
  const { t } = useTranslation();
  const { data } = useSearchQueryContext(queryName);

  const {
    loyaltyEarnOrders,
    loyaltyBurnOrders,
    loyaltyOrdersNetSales,
    discountAmount,
    activeMembers,
  } = data;

  return (
    <SummaryCardBoundary queryName={queryName} expectedCount={5}>
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.loyaltyEarnOrders.label')}
        value={loyaltyEarnOrders?.value}
        valueType={loyaltyEarnOrders?.cardType}
        previousPeriodPercent={loyaltyEarnOrders?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.loyaltyBurnOrders.label')}
        value={loyaltyBurnOrders?.value}
        valueType={loyaltyBurnOrders?.cardType}
        previousPeriodPercent={loyaltyBurnOrders?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.loyaltyOrdersNetSales.label')}
        value={loyaltyOrdersNetSales?.value}
        valueType={loyaltyOrdersNetSales?.cardType}
        previousPeriodPercent={loyaltyOrdersNetSales?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.loyaltyDiscountAmount.label')}
        value={discountAmount?.value}
        valueType={discountAmount?.cardType}
        previousPeriodPercent={discountAmount?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.activeMembers.label')}
        value={activeMembers?.value}
        valueType={activeMembers?.cardType}
        previousPeriodPercent={activeMembers?.comparisonNumber}
      />
    </SummaryCardBoundary>
  );
};

export default LocationLoyaltyPerformanceSummaryCards;
